window.$ = require('jquery')
window.JQuery = require('jquery')
window.PrismJs = require('prismjs')


import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import axios from 'axios'
import { store } from './store.js';

store.dispatch("load").then(() => {

})

router.beforeEach(function (to, from, next) {

    if (to.meta && to.meta.permissions) {
        let roles = to.meta.permissions.roles
        let permissions = to.meta.permissions.permissions
        let authenticated = to.meta.authenticated?true:false
        let clientIsOptional = to.meta.clientIsOptional?true:false

        if( authenticated == store.getters.isLoggedIn ){
            if( !clientIsOptional && !store.getters.scope ){
                next('/switch')
            }
            next()
        }else{
            store.dispatch("user").then(() => {
                if( !clientIsOptional && !store.getters.scope ){
                    next('/switch')
                }
                next()
            }).catch(e => {
                next('/login')
            });
        }

    } else {
        next()
    }
})

import {Tabs, Tab} from 'vue-tabs-component';
import Multiselect from 'vue-multiselect'

import Published from './components/Published.vue'
import Date from './components/Date.vue'
import Active from './components/Active.vue'

import FormGallery from './components/form/Gallery.vue'
import FormFile from './components/form/File.vue'
import FormFileImport from './components/form/FileImport.vue'
import FormToggle from './components/form/Toggle.vue'
import FormDate from './components/form/Date.vue'
import FormCode from './components/form/Code.vue'
import FormText from './components/form/Text.vue'
import FormSort from './components/form/Sort.vue'
import FormNumeric from './components/form/Numeric.vue'
import FormNumber from './components/form/Number.vue'
import FormTextarea from './components/form/Textarea.vue'
import FormHtml from './components/form/Html.vue'
import FormPassword from './components/form/Password.vue'
import FormSelect from './components/form/Select.vue'
import FormChecklist from './components/form/Checklist.vue'
import FormCountries from './components/form/Countries.vue'
import FormColor from './components/form/Color.vue'
import FormScopes from './components/form/Scopes.vue'
import FormColorPicker from './components/form/ColorPicker.vue'
import FormAutocomplete from './components/form/Autocomplete.vue'
import FormTag from './components/form/Tag.vue'
import Languages from './components/Languages.vue'
import Scopes from './components/Scopes.vue'
//import Modal from './components/Modal.vue'

import Paginator from './components/Paginator.vue'

import Header from './layouts/Header.vue'

import draggable from 'vuedraggable'

import VueDragResize from 'vue-drag-resize'

import { Chrome } from 'vue-color'

import VuePrismEditor from "vue-prism-editor";

//Vue.component('modal', Modal);
Vue.component('prism-editor', VuePrismEditor);
Vue.component('chrome-picker', Chrome);
Vue.component('scopes', Scopes);
Vue.component('languages', Languages);
Vue.component('draggable', draggable);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('published', Published);
Vue.component('date', Date);
Vue.component('active', Active);
Vue.component('form-scopes', FormScopes);
Vue.component('form-code', FormCode);
Vue.component('form-toggle', FormToggle);
Vue.component('form-date', FormDate);
Vue.component('form-text', FormText);
Vue.component('form-sort', FormSort);
Vue.component('form-numeric', FormNumeric);
Vue.component('form-number', FormNumber);
Vue.component('form-file', FormFile);
Vue.component('form-file-import', FormFileImport);
Vue.component('form-textarea', FormTextarea);
Vue.component('form-html', FormHtml);
Vue.component('form-select', FormSelect);
Vue.component('form-countries', FormCountries);
Vue.component('form-color', FormColor);
Vue.component('form-color-picker', FormColorPicker);
Vue.component('form-checklist', FormChecklist);
Vue.component('form-password', FormPassword);
Vue.component('form-autocomplete', FormAutocomplete);
Vue.component('form-tag', FormTag);
Vue.component('component-paginator', Paginator);
Vue.component('component-multiselect', Multiselect);
Vue.component('app-header', Header);
Vue.component('form-gallery', FormGallery);
Vue.component('vue-drag-resize', VueDragResize)

Vue.component('v-style', {
    render: function (createElement) {
        return createElement('style', this.$slots.default)
    }
});

import SortableTree from './components/Tree.vue'
Vue.component(SortableTree.name, SortableTree)

var numeral = require("numeral");
numeral.register('locale', 'fr', {
    delimiters: {
        thousands: ' ',
        decimal: '.'
    }
});
numeral.locale('fr');

Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0.00");
});
Vue.filter("formatDate", function (value) {
    var dateFormat = require('dateformat');
    let date = new Date(value)
    return dateFormat(date, 'dd.mm.yyyy HH:MM:ss');
});

Vue.filter("roundNumber", function(value){
    return Number((value).toFixed(1));
});

Array.prototype.sortOn = function(key){
    this.sort(function(a, b){
        if(a[key] < b[key]){
            return -1;
        }else if(a[key] > b[key]){
            return 1;
        }
        return 0;
    });
}

new Vue({
    el: '#app',
    router,
    store: store,
    template: '<App/>',
    components: { App },
    computed: {

    }
})




// WEBPACK FOOTER //
// ./src/main.js